import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITIES_TYPES,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
} from 'global/constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { getComponentsOfType } from '../shared/logic/get-components-of-type';
import { AnswerComponent } from './suggested-answer.constants';
import { ComponentTable } from '../component.constants';
import type { InteractiveSubActivityFragment } from '../../lesson-builder.graphql.generated';

export function getResponseComponentsFromSubSection(
  sectionId: string,
  sectionData: GetActivitiesSectionsQuery | undefined
) {
  return getComponentsOfType<AnswerComponent>({
    components:
      sectionData?.getActivitiesSections?.[0]?.subSections?.find(
        s => s.id === sectionId
      )?.components || [],
    types: ACTIVITIES_COMPONENT_SUB_ACTIVITIES_TYPES,
  });
}

export function getResponseComponentsFromSection(
  sectionData: GetActivitiesSectionsQuery | undefined
) {
  return getComponentsOfType<AnswerComponent>({
    components: sectionData?.getActivitiesSections?.[0].components || [],
    types: ACTIVITIES_COMPONENT_SUB_ACTIVITIES_TYPES,
  });
}

export function filterOutReadOnlyTable(components: AnswerComponent[]) {
  return components.filter(component => {
    if (
      component.type === ACTIVITIES_COMPONENT_TYPE_TABLE &&
      (component as ComponentTable).properties.table.isReadOnly
    ) {
      return false;
    }
    return true;
  });
}

export function getSubActivityLabel(
  subActivityProperties: InteractiveSubActivityFragment | null
) {
  return subActivityProperties
    ? {
        ...subActivityProperties,
        instructions: null,
        subActivityLabel: null,
      }
    : null;
}
